import { cn } from "@/lib/cn";
import type { EntityViewType } from "@config";
import { useIsMobile } from "@library/shared";
import type { ReactNode } from "react";
import "../styles/index.scss";

export const TabsView = ({
  entity,
  children,
  editorData,
}: {
  entity: EntityViewType;
  children: ReactNode;
  editorData?: { focus: "title" | "content" };
}) => {
  const isMobile = useIsMobile();
  const { settings } = entity;
  const EDITOR_ATTR = editorData?.focus
    ? { "data-focus-type": editorData.focus }
    : {};
  return (
    <div
      {...EDITOR_ATTR}
      data-tabs-layout={settings.tabsLayout}
      data-tabs-design={settings.tabsDesign}
      className={cn("tw-flex tw-w-full tw-break-inside-avoid", {
        "tw-grid": ["bottom", "top"].includes(settings.tabsLayout),
        "tw-items-center": ["left", "right"].includes(settings.tabsLayout),
        "tw-block": isMobile,
      })}
    >
      {children}
    </div>
  );
};
